// ============================================================================
// Switch.jsx — Corelia UI v1.2
// Design identique, architecture homogénéisée
// ============================================================================
import React from "react";
import theme from "../../../styles/theme";

const Switch = ({
  enabled = false,
  onChange,
  label = "",
  showText = true,
  size = "small",
  labelPosition = "left", // option future, non utilisée ici
  style = {},
  switchStyle = {},
}) => {

  // Tailles standardisées — inchangées
  const sizes = {
    small: { width: 24, height: 12, knob: 10 },
    medium: { width: 34, height: 18, knob: 14 },
  };
  const { width, height, knob } = sizes[size] || sizes.small;

  const isEnabled = !!enabled;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: theme.spacing.sm,
        fontFamily: theme.fonts.body,
        color: theme.colors.text.body,
        marginBottom: theme.spacing.md,
        ...style,
      }}
    >
      {/* Label (inchangé) */}
      {label && (
        <span
          style={{
            fontFamily: theme.form.label.fontFamily,
            fontSize: theme.form.label.fontSize,
            fontWeight: theme.form.label.fontWeight,
            color: theme.form.label.color,
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </span>
      )}

      {/* Switch container */}
      <div
        onClick={() => onChange(!isEnabled)}
        style={{
          width,
          height,
          borderRadius: theme.borders.radius.full,
          backgroundColor: isEnabled
            ? theme.colors.states.enabled
            : theme.colors.states.disabled,
          position: "relative",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
          flexShrink: 0,
          ...switchStyle,
        }}
      >
        {/* Knob (identique à l’original) */}
        <div
          style={{
            width: knob,
            height: knob,
            borderRadius: theme.borders.radius.full,
            backgroundColor: theme.colors.background.surface,
            position: "absolute",
            top: (height - knob) / 2,
            left: isEnabled ? width - knob - 2 : 2,
            transition: "left 0.2s ease",
            boxShadow: theme.shadows.sm,
          }}
        />
      </div>

      {/* Texte On/Off (design conservé) */}
      {showText && (
        <span
          style={{
            fontSize: theme.fontSizes.sm,
            fontWeight: theme.fontWeights.medium,
            color: isEnabled
              ? theme.colors.states.enabled
              : theme.colors.states.disabled,
          }}
        >
          {isEnabled ? "On" : "Off"}
        </span>
      )}
    </div>
  );
};

export default Switch;
